<template>
<div>

    <div class="score">

        <div class="wrapper">

            <div class="score__title">
                {{ post_title }}
            </div>

            <div class="player-filter">
                <div class="player-filter__switch">
                    <ul>
                        <li>
                            <a @click.prevent="type = 'atp'"
                               :class="{ active: type == 'atp' }"
                               href="#">
                                <span>atp</span>
                            </a>
                        </li>
                        <li>
                            <a @click.prevent="type = 'wta'"
                               :class="{ active: type == 'wta' }"
                               href="#">
                                <span>wta</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="player-filter__type">
                    <select ref="dayselector" id="dayselector" name="dayselector" v-model="selectedDay">
                        <option v-for="(day, dayIndex) in oop" :value="day.date">Day {{dayIndex+seq}} -
                            {{formatDate(day.date)}}
                        </option>
                    </select>
                </div>
            </div>

        </div>
    </div>

    <div class="wrapper wrapper--scoring">
        <div v-for="day in dayOOP" class="OOP-day">

            <oop-court v-for="court in day.courts"
                       v-if="showCourtForType(court)"
                       :key="court.id"
                       :type="type"
                       :flagPath="flagPath"
                       :detail="detail"
                       :court="court"
                       :events="events">
            </oop-court>
        </div>

        <div class="na">
            <div class="na__info" v-html="ico_info"></div>

            <div class="na__title" style="margin-bottom: 0">
                No matches for this day
            </div>
        </div>
    </div>

</div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import OOPCourt from './OOPCourt'
    import 'select2/dist/js/select2.full.js'

    export default {
        components: {
            'oop-court': OOPCourt
        },
        props: [ 'flag', 'detail', 'tournament', 'pretype', 'post_title' ],
        data() {
            return {
                oop             : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                selectedDay     : '',
                type            : this.pretype,
                tournament_slug : this.tournament,
                allMtch         : [],
                seq             : '',
                ico_info        : window.ico_info,
                events          : [],
            }
        },
        created() {
            this.getFeed()
            this.setupRounds()
        },
        watch: {
            type() {
                this.getFeed()
            }
        },
        computed: {
            dayOOP() {
                return this.oop.filter(days => days.date == this.selectedDay)
            }
        },
        mounted() {
            let app = this
            jQuery('#dayselector').select2({
                width: '100%'
            }).on('change', function () {
                app.selectedDay = this.value
            })
        },
        methods: {
            getFeed() {
                axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/oop`).then(response => {

                    this.oop = this.filterMatchesByType( response.data, this.type )

                    let totalDaysCount = response.data.length

                    if ( totalDaysCount ) {
                        this.seq = parseInt(response.data[0].seq)

                        let today = moment().tz('Asia/Dubai').startOf('day').format('YYYY-MM-DD')
                        let nowTime = moment().tz('Asia/Dubai').format('HH')

                        // console.log(today, 'todayyyyy')


                        if( totalDaysCount == 1 ){

                            // console.log('nu ar trebui sa intre aici');

                            if( response.data[totalDaysCount - 1] )
                                this.selectedDay = response.data[totalDaysCount - 1].date

                        } else {

                            // console.log('ar trebui sa intre aici');
                            //
                            // console.log('total-dasy count',response.data[totalDaysCount - 1].date)
                            //
                            // console.log('today',today)
                            //
                            // console.log('nowtime', nowTime);

                            if ( this.selectedDay.length < 1 ) {

                                if ( nowTime < 20 ){
                                    this.selectedDay = today
                                    // console.log('daca timpul e mai mic de 24')
                                }else{
                                    this.selectedDay = response.data[totalDaysCount - 1].date
                                    // console.log('ar trebui sa fie ziua urmatoarea setata aici daca timpul nu e mai mic decat 24');
                                }

                            }

                        }

                    }
                }).catch(function (error) {
                    console.log(error)
                })

            },
            setupRounds() {
                axios.get(`${window.feed_ip}/${this.type}/update/rounds/${this.tournament_slug}`).then(response => {

                    this.events = response.data

                }).catch(function (error) {
                    console.log(error)
                })

            },
            formatDate(date) {
                return date
                //return moment(date).format('MMMM DD')
            },
            showCourtForType(court) {
                let possibleMatches;

                if (this.type == 'all') {
                    return true
                }

                possibleMatches = court.matches.filter(match => match.type == this.type)

                if (possibleMatches.length == 0) {
                    return false
                }

                return true
            },
            getAllMatchesInOneArray(days) {
                let allMatches = []

                for (let day of days) {
                    for (let court of day.courts) {
                        allMatches.push(...court.matches)
                    }
                }

                return allMatches
            },
            filterMatchesByType(days, type) {
                days.forEach( function( day, i ) {
                    day.courts.forEach( function ( court, j ) {
                        day.courts[j].matches = court.matches.filter( function( match ) {
                            if ( match.type == type )
                                return true
                        })
                    })
                })

                return days
            }
        }
    }
</script>
